import { useEffect, useState, type RefObject } from 'react';

/**
 * Content-width-aware column count for the hourly inventory grid.
 * Laptop/desktop targets at least 4 columns; scales up/down with workspace width.
 */
export function useContentColumns(
  containerRef: RefObject<HTMLElement | null>,
  fallback = 4,
) {
  const [columns, setColumns] = useState(fallback);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;

    const measure = () => {
      const w = el.clientWidth;
      // Phones stay at 2 cols so inventory stays scannable above the fold
      if (w < 420) setColumns(2);
      else if (w < 640) setColumns(2);
      else if (w < 820) setColumns(3);
      else if (w < 1100) setColumns(4);
      else if (w < 1400) setColumns(5);
      else setColumns(6);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [containerRef]);

  return columns;
}
